export const
    cstEnterprise = {
        path: "/safetyCheck/cstEnterprise",
        component: require("@/components/pages/safetyCheck/cstEnterprise/main.vue"),
        children: [{ //施工企业基本信息
                path: "/safetyCheck/cstEnterprise/enterpriseBaseInfor",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/enterpriseBaseInfor.vue"], resolve),
                meta: { componentName: "enterpriseBaseInfor" }
            }, { //施工企业自评(填报)
                path: "/safetyCheck/cstEnterprise/etpEvalueSelf",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/etpEvalueSelf.vue"], resolve),
                meta: { componentName: "etpEvalueSelf" }
            }, { //施工企业考评(填报)
                path: "/safetyCheck/cstEnterprise/etpEvalueFill",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/etpEvalueFill.vue"], resolve),
                meta: { componentName: "etpEvalueFill" }
            }, { //施工企业考评结果公示书
                path: "/safetyCheck/cstEnterprise/resultPublicNotice",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/resultPublicNotice.vue"], resolve),
                meta: { componentName: "resultPublicNotice" }
            }, { //施工企业考评结果告知书
                path: "/safetyCheck/cstEnterprise/resultNotice",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/resultNotice.vue"], resolve),
                meta: { componentName: "resultNotice" }
            }, { //企业考评异议复核(查询)
                path: "/safetyCheck/cstEnterprise/dissentReview",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/dissentReview.vue"], resolve),
                meta: { componentName: "dissentReview" }
            }, { //施工企业考评(查询)
                path: "/safetyCheck/cstEnterprise/etpEvalueQuery",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/etpEvalueQuery.vue"], resolve),
                meta: { componentName: "etpEvalueQuery" }
            }, { //撤销企业考评结果(查询)
                path: "/safetyCheck/cstEnterprise/revokeResult",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/revokeResult.vue"], resolve),
                meta: { componentName: "revokeResult" }
            }, { //撤销企业考评结果公示书
                path: "/safetyCheck/cstEnterprise/revokePublic",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/revokePublic.vue"], resolve),
                meta: { componentName: "revokePublic" }
            }, { //撤销企业考评结果决定书
                path: "/safetyCheck/cstEnterprise/revokeDecision",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/revokeDecision.vue"], resolve),
                meta: { componentName: "revokeDecision" }
            }, { //重新申请安全生产标准化考核(登记)
                path: "/safetyCheck/cstEnterprise/reapplyRegister",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/reapplyRegister.vue"], resolve),
                meta: { componentName: "reapplyRegister" }
            }, { //重新申请安全生产标准化考核(查询)
                path: "/safetyCheck/cstEnterprise/reapplyQuery",
                component: resolve => require(["../components/pages/safetyCheck/cstEnterprise/reapplyQuery.vue"], resolve),
                meta: { componentName: "reapplyQuery" }
            },

        ]
    }


// WEBPACK FOOTER //
// ./src/router/cstEnterprise.js